module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.32941d6330044744c024.svg";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.halflings.pro/glyphicons-halflings-regular.svg
// module id = ../../../../../src/assets/css/fonts/glyphicons.halflings.pro/glyphicons-halflings-regular.svg
// module chunks = 2